import {
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  BETSLIP_OPENED,
  PLAY_COUPON_SUCCESS,
  SET_LIVE_STREAM_STOP,
  SET_LIVE_STREAM_START,
  GET_MATCH_CARD_EVENT_SUCCESS,
  ADD_EVENT_TO_BETSLIP_SUCCESS,
  REMOVE_EVENT_FROM_BETSLIP,
  RESET_BETSLIP,
  SEND_COMMENT_SUCCESS,
  SEND_COMMENT_FAILURE,
  LIKE_OR_UNLIKE_COUPON_SUCCESS,
  SHARE_TRIBUN_COUPON_SUCCESS,
  UPDATE_USER_BALANCE_SUCCESS,
  FORGOT_PASSWORD_OPTIONS_SUCCESS,
  FORGOT_PASSWORD_OPTIONS_FAILURE,
  SAVE_FORGOT_PASSWORD_UNKNOWN_USER_DATA,
  FORGOT_PASSWORD_SEND_EMAIL_REQUEST,
  FORGOT_PASSWORD_SEND_OTP_REQUEST,
  FORGOT_PASSWORD_OTP_VERIFY_SUCCESS,
  FORGOT_PASSWORD_CHANGE_WITH_PHONE_NUMBER_SUCCESS,
  FORGOT_PASSWORD_CHANGE_WITH_EMAIL_SUCCESS,
  ADD_MULTIPLE_EVENTS_TO_BETSLIP_SUCCESS,
  GET_CONTINUED_COUPONS_SUCCESS,
  GET_WON_COUPONS_SUCCESS,
  GET_LOST_COUPONS_SUCCESS,
  GET_SAVED_COUPONS_SUCCESS,
  GET_REJECTED_COUPONS_SUCCESS,
  SPOR_TOTO_COUPONS_SUCCESS,
  SPOR_TOTO_COUPONS_FAILURE,
  SPOR_TOTO_PLAY_SUCCESS,
  SPOR_TOTO_RESULT_BY_WEEKLY_SUCCESS,
  SPOR_TOTO_GET_POPULAR_SELECTIONS,
  SPOR_TOTO_RANDOM_SELECTIONS,
  SPOR_TOTO_GET_EVENTS_SUCCESS,
  SPOR_TOTO_CANCEL_COUPON_SUCCESS,
  SPOR_TOTO_DELETE_SAVED_COUPON_SUCCESS,
  BETSLIP_SETTINGS_OPENED,
  BETSLIP_SETTINGS_UPDATED,
  SPORTSBOOK_FILTER_CLICKED,
  VIEW_EVENT_LIST_MIXPANEL,
  GET_OUT_RIGHT_CONTINUE_COUPONS_SUCCESS,
  GET_OUT_RIGHT_WON_COUPONS_SUCCESS,
  GET_OUT_RIGHT_LOST_COUPONS_SUCCESS,
  GET_OUT_RIGHT_SAVED_COUPONS_SUCCESS,
  SPACE_COUPON_MIX_PANEL,
  SET_TJK_LIVE_STREAM_START,
  SET_TJK_LIVE_STREAM_STOP,
  FOLLOW_TRIBUN_USER_SUCCESS,
  GET_PUSH_FOLLOW_SUCCESS,
  GET_PUSH_UNFOLLOW_SUCCESS,
  MUTE_TRIBUN_USER_SUCCESS,
  HIDE_TRIBUN_FEED_COUPON_SUCCESS,
  FAST_DEPOSIT_VIEW_PAGE,
  FAST_DEPOSIT_CLICK_SEND_REQUEST,
  FAST_DEPOSIT_CLICK_CANCEL_BUTTON,
  FAST_DEPOSIT_CLICK_CONFIRM_BUTTON,
  FAST_DEPOSIT_CLICK_HOW_TO_BUTTON,
  FAST_DEPOSIT_CLICK_HELP_BUTTON,
  FAST_DEPOSIT_CLICK_CANCEL_INFO,
  FAST_DEPOSIT_VIEW_CANCEL_REASON,
  FAST_DEPOSIT_CLICK_RETRY_BUTTON
} from 'Store/constants';

import {
  EVENT_FIELD_MAPPING,
  GTA_SPORT_TYPE_NAMING,
  SORTBYLEAGUE,
  BYTIME,
  SORTBYPOPULAR,
  SORTBYPERSONAL,
  SEARCH,
  FILTER_DATA_TYPES,
  SPORTSBOOK,
  BULLETIN_TYPES,
  SPACE_COUPON_MIXPANEL_MAP,
  FAVORITES
} from 'Store/constants/sportTypes';

import {
  addOddAddedPoint,
  pageFinder,
  finderTab,
  getCouponSetlement,
  getCouponHasLive,
  timeConverter,
  hasLiveEventConverter,
  couponCountCheck,
  isLiveEvent,
  costConverter,
  shareCouponPlace,
  tribunUsernameCheck,
  buildTribunMixPanelFilterData,
  muteMutePointHelper } from 'Utils/mixPanelTribunHelper';

import { TRIBUN_FILTER_SORT_OPTIONS } from 'Store/constants/tribun';
import EnvironmentManager from 'Utils/environmentManager';

const { FILTER_V2, SORT } = TRIBUN_FILTER_SORT_OPTIONS;


const {
  sportType,
  leagueName,
  eventStartDate,
  bettingPhase,
  hasLiveStream,
  channel,
  homeTeamName,
  awayTeamName,
} = EVENT_FIELD_MAPPING;

import mixpanel from 'Utils/mixpanel';
import History from 'Store/history';
import { mixpanelFilterParser } from 'Utils/mixPanelBulletinHelper';
import LocalStorage from 'Utils/localStorage';
import { getDefaultStakeLimits } from 'Utils/getDefaultStakeAmount';
import qs from 'query-string';
import { bultenOrderFilterStatus, tribunPageTypeHelper } from 'Utils/mixPanelTribunHelper';
import { getThemeMixpanelValue } from 'Utils/theme';

const SPORT_TYPE_NAMING = {
  SOCCER: 'Futbol',
  BASKETBALL: 'Basketbol'
};

const betAddedPoints = new Map();

const getRenewTypeOptions = state => {
  const { email, phoneNumber } = state.membership?.forgotPassword?.options?.data || {};
  const canAddNewPhone = EnvironmentManager.getMessageText({ key: 'new_pw_reset_add_new_phone_switch' }) === 'true';
  const newPhone = canAddNewPhone ? ['New Phone Number'] : [];

  if (email && phoneNumber) return ['E-mail', 'Telefon', ...newPhone];
  if (phoneNumber) return ['Telefon', ...newPhone];
  if (email) return ['E-mail', ...newPhone];
  return [];
};

export const mixpanelDataCollector = ({ getState }) => {
  let liveStreamTracker = [];
  let liveStatisticsTracker = [];
  const formatProbability = value => {
    const percentage = value * 100;
    if (percentage < 0.01) return '0.01';
    return percentage.toFixed(2);
  };
  return next => action => {
    const state = getState();
    // Complete Login
    if (action.type === LOGIN_SUCCESS) {
      mixpanel.people.set_once({ 'Default Stake': getDefaultStakeLimits().min });
      const checkAndSendData = () => {
        const { auth: { data } } = getState();

        if (data && data.isAcceptedPersonalizationPolicy !== undefined) {
          const hasLoggedBefore = localStorage.getItem('hasLoggedBefore');
          if (!hasLoggedBefore) {
            const mixpanelCompletePayload = {
              Personalization: data.isAcceptedPersonalizationPolicy,
              'Last Login Time': new Date().toISOString(),
              'Year of Birth': action.payload.yearOfBirth,
              Occupation: data.occupationName,
              'User Status': 'Active',
            };

            mixpanel.track('Complete Login', mixpanelCompletePayload);

            if (localStorage.getItem('loginWithReference')) {
              mixpanelCompletePayload['Reference Code'] = localStorage.getItem('loginWithReference');
            }
            if (state.auth.isAuthenticated) {
              mixpanel.people.set({
                'Last Login Time': new Date().toISOString(),
                'Year of Birth': action.payload.yearOfBirth,
                Personalization: data.isAcceptedPersonalizationPolicy,
              });
            }

            localStorage.setItem('hasLoggedBefore', 'true');
          }
        } else {
          setTimeout(checkAndSendData, 100);
        }
      };

      checkAndSendData();
    }

    if (action.type === LOGOUT_SUCCESS) {
      // Oturum kapatıldığında bayrağı temizle
      localStorage.removeItem('hasLoggedBefore');
    }

    // View Event Detail
    if (action.type === GET_MATCH_CARD_EVENT_SUCCESS) {
      if (state.auth.isAuthenticated)
        mixpanel.people.increment('Number of Event Views');
      if (state.matchCard.event?.clickedPoint !== '') {
        mixpanel.track('View Event Detail', {
          'Event ID': action.payload.codeInt ?? action.payload.id,
          Teams: [action.payload[homeTeamName], action.payload[awayTeamName]],
          'Event Type': action.payload[bettingPhase] === 1 ? 'Canlı' : 'İddaa',
          'Event Sport': GTA_SPORT_TYPE_NAMING[action.payload[sportType]],
          'Event League': action.payload[leagueName],
          'Event Time': action.payload[eventStartDate],
          'Play Ratio Toggle': false,
          'Event Stream Available': [1, 3].includes(action.payload[hasLiveStream]),
          'Tv Info': action.payload[channel],
          'Click Point': state.matchCard.event?.clickedPoint
        });
      }
    }
    if (action.type === ADD_MULTIPLE_EVENTS_TO_BETSLIP_SUCCESS) {
      const betCount = state.betSlip.coupon?.bets?.length || 0;
      if (betCount > 0) {
        liveStatisticsTracker.push(...Array(betCount).fill('unknown'));
      }
    }
    // Add Odd
    if (action.type === ADD_EVENT_TO_BETSLIP_SUCCESS) {
      const isUndo = action.payload.isUndo === true;
      const eventId = action.payload.event?.eventId;

      let tempPath = addOddAddedPoint(History.location.pathname);
      let tempTabObj = finderTab(History.location.pathname);

      let liveStatValue = 'unknown';
      if (History.location.pathname.includes('/mac-karti')) {
        const matchCardHeader = state.matchCard?.header?.data;
        const hasLiveStatisticsTab = matchCardHeader?.availableTabs?.some(tab =>
          (tab.type || tab.tabType) === 'STATISTICS' && tab.subTabs?.some(subTab => (subTab.type || subTab.tabType) === 'LIVE_STATISTICS')
        );

        if (hasLiveStatisticsTab) {
          liveStatValue = 'yes';
        } else {
          liveStatValue = 'no';
        }
      }
      liveStatisticsTracker.push(liveStatValue);

      if (action?.payload?.tabName === 'sicak-bahisler') {
        tempPath = 'Maç Kartı Sıcak Bahisler';
      } else if (action?.payload?.tabName === 'bahista') {
        tempPath = 'Maç Kartı Bahista';
      } else if (tempPath === 'Anasayfa') {
        if (action?.payload?.tabName === 'sana-ozel-populer-bahisler')
          tempPath = 'Sana Ozel Anasayfa';
        else if (action?.payload?.tabName === 'populer-bahisler')
          tempPath = 'Populer Anasayfa';
      } else if (tempPath === 'Oranlar') {
        if (action?.payload?.tabName === 'Sana Özel')
          tempPath = 'Sana Ozel Match Card';
        else if (action?.payload?.tabName === 'En Popüler')
          tempPath = 'Populer Match Card';
      } else if (tempPath === 'Coupon Success') {
        if (action?.payload?.tabName === 'sana-ozel-populer-bahisler')
          tempPath = 'Coupon Success Page-Popular';
        else if (action?.payload?.tabName === 'populer-bahisler')
          tempPath = 'Coupon Success Page-Popular';
        else if (action.payload.tabName === '' && action.payload.source !== 'RECOMMENDED_COUPON')
          tempPath = 'Coupon Success Page-My Coupon';
      } else if (tempPath === 'Kupon Getir') {
        tempPath = 'Kupon Getir';
      } else if (action?.payload?.tabName === 'sicak-bahisler') {
        tempPath = 'Maç Kartı Sıcak Bahisler';
      } else {
        if (action?.payload?.tabName === 'filterAndSortPersonal')
          tempPath = state.auth.isAuthenticated && state.auth.data.isAcceptedPersonalizationPolicy ? 'Sana Ozel Bulten' : 'Populer Bulten';
      }
      const params = History.location.search;
      let referrer = '';
      if (params) {
        const eventMatch = params.match(/event=([^&]*)/);
        if (eventMatch && eventMatch[1]) {
          const eventParam = eventMatch[1];
          const eventParts = eventParam.split('-');
          referrer = eventParts[eventParts.length - 1];
        }
      }

      const dataSource = action?.payload?.source === SPORTSBOOK ? tempPath : action?.payload?.source;
      let recommendedPath;

      if (dataSource === 'RECOMMENDED_COUPON' && (tempPath === 'Coupon Success')) {
        recommendedPath = 'Suggest-Coupon Success Page';
      } else if (dataSource === 'RECOMMENDED_COUPON' && tempPath === 'Yazar Yorumları') {
        recommendedPath = 'Suggest - Prof Bahista';
      } else if (dataSource === 'RECOMMENDED_COUPON' && tempPath === 'Anasayfa Search') {
        recommendedPath = 'Main Page Search-Popular';
      }
      const isLivePlaying = getState()?.liveStream?.hasRun;
      let isLivePlayingTracker;
      if (state.betSlip?.couponDetails?.map(event => event.eventId)?.[0] !== action.payload.event?.eventId) {
        isLivePlayingTracker = action.payload.event?.eventId  !== LocalStorage.get('liveStreamStop') && isLivePlaying ? 'true' : 'false';
        liveStreamTracker?.push(isLivePlayingTracker);
      }

      const tabType = finderTab(History.location.pathname).tabType;

      const activeFilter
          = buildTribunMixPanelFilterData(
            LocalStorage.get(FILTER_V2.appliedFiltersLocalStorageKey) || {},
            getState().tribun?.tribunSortingOptions?.filterTabs || [],
            FILTER_V2.filterKeyMap,
            tabType,
            FILTER_V2.defaultSelectedFilters
          )?.activeFilterList;

      const activeSort
        = (LocalStorage.get(SORT.localStorageKey) || {})?.[tabType]?.value
        || (getState().tribun?.tribunSortingOptions?.sortingOptions?.data?.[0]?.value)
        || '-';

      // eslint-disable-next-line no-nested-ternary
      const computedAddedPoint = (referrer !== undefined && referrer !== '') ? referrer : (dataSource === 'RECOMMENDED_COUPON' ? recommendedPath : dataSource);

      const addedPoint = isUndo
        ? (betAddedPoints.get(eventId) ?? computedAddedPoint)
        : computedAddedPoint;

      if (!isUndo && eventId) {
        betAddedPoints.set(eventId, computedAddedPoint);
      }

      const addOddPayload = {
        'Added Point': addedPoint,
        'Bringed Coupon Row': (tempPath === 'Kupon Getir') ? String(action.payload.bringedCouponRow || '-') : '-',
        'Bet on Live Stream': isLivePlayingTracker,
        'Event ID': action.payload.event?.eventId,
        Teams: action.payload.eventDetails?.name?.split('-'),
        'Event Type': action.payload.eventDetails?.isLive ? 'Canlı' : 'İddaa',
        'Event Sport': GTA_SPORT_TYPE_NAMING[action.payload.eventDetails?.sportType],
        'Event League': action.payload.eventDetails?.leagueName,
        'Event Time': action.payload.eventDetails?.eventStartDate,
        'Event Stream Available': [1, 3].includes(action.payload.eventDetails?.hasLiveStream),
        'Tv Info': action.payload.eventDetails?.channel,
        'Market Name': action.payload.eventDetails?.bets[0]?.marketName,
        'Selection Name': action.payload.eventDetails?.bets[0]?.betType,
        Odd: action.payload.event?.odds,
        'Odd MBS': action.payload.event?.mbs,
        'Coupon Type': tempPath === 'Tribün Kupon' ? 'Tribun' : '',
        'Tribun User Name': tempPath === 'Tribün Kupon' ? state.tribun.tribunCouponDetails?.data?.user?.username : '',
        'Active Tab': tempTabObj.tabPoint,
        'Page Type': tempPath === 'Tribün Kupon' ? pageFinder(History.location.pathname) : '',
        'Page Name': tempPath === 'Yazar Yorumları' ? 'Tribün-Yazarlar' : pageFinder(History.location.pathname),
        'Active Filter': tempPath === 'Tribün Kupon' ? activeFilter : '',
        'Active Sort': tempPath === 'Tribün Kupon' ? activeSort : '',
        'Tribun Bet Coupon ID': tempPath === 'Tribün Kupon' ? state.tribun.tribunCouponDetails?.data?.feedId : '',
        'Tribun Like Count': tempPath === 'Tribün Kupon' ? state.tribun.tribunCouponDetails?.data?.likes : '',
        'Tribun Comment Count': tempPath === 'Tribün Kupon' ? state.tribun.tribunCouponDetails?.data?.comments : '',
        'Writer Name': action?.payload?.writerName || '-',
        'Year of Birth': state.auth.data.yearOfBirth,
        'Top Win': !!action.payload.event?.topWinOdds,
        'Added Top Win': state.auth.data?.topWinEnabled ? action.payload.event?.topWinOdds : undefined,
      };

      // Probability Level yalnızca Maç Kartı Bahista kaynaklı Add Odd için
      if (addedPoint === 'Maç Kartı Bahista' && action.payload.probabilityLevel) {
        addOddPayload['Probability Level'] = action.payload.probabilityLevel;
      }

      mixpanel.track('Add Odd', addOddPayload);
    }

    // View Betslip
    if (action.type === BETSLIP_OPENED) {
      mixpanel.track('View Betslip', {
        'Event ID List': state.betSlip?.couponDetails?.map(event => event.eventId),
        'Teams List': state.betSlip?.couponDetails?.map(event => event.name),
        'Event Type List': state.betSlip?.couponDetails?.map(event =>  event?.isLive ? 'Canlı' : 'İddaa'),
        'Event Sport List': state.betSlip?.couponDetails?.map(event => GTA_SPORT_TYPE_NAMING[event.sportType]),
        'Event Time List': state.betSlip?.couponDetails?.map(event => event?.eventId),
        'Event League List': state.betSlip?.couponDetails?.map(event => event?.leagueName),
        'Market Name List': state.betSlip?.couponDetails?.map(event => event?.bets[0]?.marketName),
        'Selection List': state.betSlip?.couponDetails?.map(event => event?.bets[0]?.betType),
        Odd: state.betSlip?.coupon?.bets?.map(bet => bet?.odds),
        'Bet Type': state.betSlip?.hasLiveEvent ? 'Canlı' : 'İddaa',
        'Event Count': state.betSlip?.atrium?.betCount,
        'Total Odds': state.betSlip?.atrium?.odd,
        'Tribun Bet': !!state.betSlip?.coupon?.sourceCouponId,
        'Tribun Bet User': state.betSlip?.coupon?.sourceCouponId ? state.betSlip?.coupon?.source : '',
        'Predicta Bonus User': Boolean(state.userCampaign?.predictaBonusCampaign?.data && Object.keys(state.userCampaign.predictaBonusCampaign?.data).length > 0),
        'Predicta Percentage': formatProbability(state.betSlip?.validateData?.data?.calculatedProbability),
        'Predicta Suggestion User': state.userCampaign?.predictaSuggestion?.data?.existsInRecommendationTargetAudience
      });
    }

    // Betslip Settings
    if (action.type === BETSLIP_SETTINGS_OPENED) {
      mixpanel.track('Betslip Settings Clicked');
    }

    if (action.type === BETSLIP_SETTINGS_UPDATED) {
      const settings = action.payload;
      mixpanel.track('Betslip Settings Updated', {
        'Quick Bet(Live)': !!settings.acceptLiveEvents,
        'Quick Bet(Pre)': !!settings.acceptPrematchEvents,
        'Increasing Odds': !!settings.acceptHigherOdds,
        'Decreasing Odds': !!settings.acceptLowerOdds,
      });
      mixpanel.people.set({ 'Default Stake': settings.defaultStakeAmount });
    }
    // Complete Place Bet
    if (action.type === PLAY_COUPON_SUCCESS || action.type === ADD_EVENT_TO_BETSLIP_SUCCESS || action.type === REMOVE_EVENT_FROM_BETSLIP || action.type === RESET_BETSLIP || action.type === ADD_MULTIPLE_EVENTS_TO_BETSLIP_SUCCESS) {
      if (action.type === ADD_EVENT_TO_BETSLIP_SUCCESS || action.type === ADD_MULTIPLE_EVENTS_TO_BETSLIP_SUCCESS) {
        let tempPath = addOddAddedPoint(History.location.pathname);
        let dataSource;
        if (tempPath === 'Anasayfa') {
          if (action?.payload?.tabName === 'sana-ozel-populer-bahisler')
            tempPath = 'Sana Ozel Anasayfa';
          else if (action?.payload?.tabName === 'populer-bahisler')
            tempPath = 'Populer Anasayfa';
        } else if (tempPath === 'Oranlar') {
          if (action?.payload?.tabName === 'Sana Özel')
            tempPath = 'Sana Ozel Match Card';
          else if (action?.payload?.tabName === 'En Popüler')
            tempPath = 'Populer Match Card';
        } else if (tempPath === 'Coupon Success') {
          if (action?.payload?.tabName === 'sana-ozel-populer-bahisler')
            tempPath = 'Coupon Success Page-Popular';
          else if (action?.payload?.tabName === 'populer-bahisler')
            tempPath = 'Coupon Success Page-Popular';
          else if (action.payload.tabName === '' && action.payload.source !== 'RECOMMENDED_COUPON')
            tempPath = 'Coupon Success Page-My Coupon';
        } else if (tempPath === 'Kupon Getir') {
          tempPath = 'Kupon Getir';
        } else if (action?.payload?.tabName === 'bahista') {
          tempPath = 'Maç Kartı Bahista';
        } else if (action?.payload?.tabName === 'sicak-bahisler') {
          tempPath = 'Maç Kartı Sıcak Bahisler';
        } else {
          if (action?.payload?.tabName === 'filterAndSortPersonal')
            tempPath = state.auth.isAuthenticated ? 'Sana Ozel Bulten' : 'Populer Bulten';
        }

        const params = History.location.search;
        let referrer = '';
        if (params) {
          const eventMatch = params.match(/event=([^&]*)/);
          if (eventMatch && eventMatch[1]) {
            const eventParam = eventMatch[1];
            const eventParts = eventParam.split('-');
            referrer = eventParts[eventParts.length - 1] !== null ? eventParts[eventParts.length - 1] : '';
          }
        }

        dataSource = (action.payload.source === SPORTSBOOK || !action.payload.source) ? tempPath : action.payload.source;
        let recommendedPath;
        if (dataSource === 'RECOMMENDED_COUPON' && (tempPath === 'Coupon Success')) {
          recommendedPath = 'Suggest-Coupon Success Page';
        } else if (dataSource === 'RECOMMENDED_COUPON' && tempPath === 'Yazar Yorumları') {
          recommendedPath = 'Suggest - Prof Bahista';
        }

        // Tribün’de addedBetPoint kullanıcı ismi gönderiliyordu, ilgili task ile override edilerek kaldırıldı.
        if (tempPath === 'Tribün Kupon') {
          dataSource = 'Tribün Kupon';
        }

        // eslint-disable-next-line no-nested-ternary
        const addedBetPoint = (referrer !== undefined  && referrer !== '') ? referrer : (dataSource === 'RECOMMENDED_COUPON' ? recommendedPath : dataSource);

        const oldAddedBetPoint = LocalStorage.get('addedBetPointArr') !== undefined ? LocalStorage.get('addedBetPointArr') : '';
        if (oldAddedBetPoint !== undefined && oldAddedBetPoint !== null && oldAddedBetPoint !== '') {
          LocalStorage.set('addedBetPointArr', oldAddedBetPoint + ',' + addedBetPoint );
        } else if ( addedBetPoint !== undefined && addedBetPoint !== null) {
          LocalStorage.set('addedBetPointArr', addedBetPoint );
        }

        if (action.type === ADD_MULTIPLE_EVENTS_TO_BETSLIP_SUCCESS && action.payload.events) {
          action.payload.events.forEach(event => {
            if (event.eventId) {
              betAddedPoints.set(event.eventId, addedBetPoint);
            }
          });
        }
      } else if (action.type === REMOVE_EVENT_FROM_BETSLIP) {
        const { oddId } = action.payload;
        const { betSlip: { couponDetails } } = getState();

        const indexToRemove = couponDetails.findIndex(item => +item.eventId === +oddId.split(':')[0]);
        liveStreamTracker?.pop(indexToRemove);
        liveStatisticsTracker?.pop(indexToRemove);
        const oldAddedBetPoint = LocalStorage.get('addedBetPointArr') !== undefined ? LocalStorage.get('addedBetPointArr') : '';
        let splittedArray = oldAddedBetPoint?.split(',');
        if (indexToRemove >= 0 && indexToRemove < splittedArray?.length) {
          splittedArray?.splice(indexToRemove, 1);
        }
        LocalStorage.set('addedBetPointArr', (splittedArray?.join(',') !== undefined && splittedArray?.join(',') !== null) ? splittedArray?.join(',') : '');

      } else if (action.type === RESET_BETSLIP) {
        liveStreamTracker = [];
        liveStatisticsTracker = [];
        LocalStorage.remove('addedBetPointArr');
      } else {
        const { data: userData } = state.auth;
        const { bets } = state.betSlip.coupon;
        const isQuickBet = bets?.length === 1 && bets[0].mbs === 1;

        const hasTribun = History.location.pathname.includes('tribun');
        const source = action.payload.coupon && action.payload.coupon.sourceCouponId ? action.payload.coupon.source : '';

        bets
          ? bets.map(b => b?.isLive ? 'Canlı' : 'İddaa')
          : [];

        const addedBetPointList = LocalStorage.get('addedBetPointArr')
          ? LocalStorage.get('addedBetPointArr').split(',')
          : '';
        const completePlaceBetPayload = {
          'Live Statistics': liveStatisticsTracker,
          'Bet on Live Stream': liveStreamTracker,
          'Event ID List': state.betSlip?.couponDetails?.map(event => event?.eventId),
          'Teams List': state.betSlip?.couponDetails?.map(event => event?.name),
          'Event Type List': state.betSlip?.couponDetails?.map(event =>  event?.isLive ? 'Canlı' : 'İddaa'),
          'Event Sport List': state.betSlip?.couponDetails?.map(event => GTA_SPORT_TYPE_NAMING[event.sportType]),
          'Event Time List': state.betSlip?.couponDetails?.map(event => event?.eventId),
          'Event League List': state.betSlip?.couponDetails?.map(event => event?.leagueName),
          'Market Name List': state.betSlip?.couponDetails?.map(event => event?.bets[0]?.marketName),
          'Selection List': state.betSlip?.couponDetails?.map(event => event?.bets[0]?.betType),
          Odd: state.betSlip?.coupon?.bets?.map(bet => bet?.odds),
          'Bet Type': state.betSlip?.hasLiveEvent ? 'Canlı' : 'İddaa',
          'Event Count': state.betSlip?.atrium?.betCount,
          'Total Odds': state.betSlip?.atrium?.odd,
          'Possible Win': action.payload.coupon?.expectedWinAmount,
          'Bet Amount': action.payload.coupon?.couponCost / action.payload.coupon?.couponCount,
          'Multiple Coupon': action.payload.coupon?.couponCount,
          'Total Bet Amount': action.payload.coupon?.couponCost,
          'System Bet': state.betSlip?.coupon?.system.length > 1 || state.betSlip?.coupon?.system[0] !== state.betSlip?.atrium?.betCount,
          'System Options': state.betSlip?.coupon?.system,
          'Tribun Bet': hasTribun,
          'Tribun Bet User': hasTribun ? source : '',
          'Coupon ID': action.payload.couponId,
          'Setting Live Bet': userData.acceptLiveEvents,
          'Setting Pre Bet': userData.acceptPrematchEvents,
          'Setting Odd Increase': userData.acceptHigherOdds,
          'Setting Odd Decrease': userData.acceptLowerOdds,
          'Quick Bet': isQuickBet,
          'Writer Name': state.betSlip?.couponDetails?.map(event => event?.writerName || '-'),
          'Year of Birth': userData.yearOfBirth,
          Occupation: userData.occupationName,
          'Added Rebet Button': state.betSlip?.addedRebetButton,
          'Added Rebet Button Tab Name': state.betSlip?.addedRebetButtonTabName,
          'Added Bet Point': addedBetPointList,
          'Added Top Win': userData?.topWinEnabled ? state.betSlip?.coupon?.bets?.map(bet => bet?.topWinOdds) : undefined,
          'Top Win': state.betSlip?.coupon?.bets?.some(bet => bet?.topWinOdds),
          'Predicta Percentage': formatProbability(state.betSlip?.validateData?.data?.calculatedProbability),
          'Predicta Suggestion Accepted': state.betSlip?.predictaSuggestionAccepted,
          Theme: getThemeMixpanelValue(),
        };

        // Probability Level yalnızca Added Bet Point içinde Maç Kartı Bahista olan kuponlar için
        const hasBahistaBetPoint = Array.isArray(addedBetPointList)
          && addedBetPointList.includes('Maç Kartı Bahista');
        if (hasBahistaBetPoint) {
          completePlaceBetPayload['Probability Level'] = state.betSlip?.couponDetails?.map(
            (event, index) => (
              addedBetPointList[index] === 'Maç Kartı Bahista'
                ? (event?.probabilityLevel || '-')
                : '-'
            )
          );
        }

        mixpanel.track('Complete Place Bet', completePlaceBetPayload);

        if (LocalStorage.get('addedBetPointArr') !== null) {
          LocalStorage.remove('addedBetPointArr');
        }

        liveStatisticsTracker = [];
        liveStreamTracker = [];
        if (state.auth.isAuthenticated) {
          mixpanel.people.set({ 'Last Place Bet Time': new Date().toISOString() });
          mixpanel.people.increment('User Bet Count');
          mixpanel.people.increment('User Bet Amount', action.payload.coupon?.couponCost);
          if (state.betSlip?.hasLiveEvent) {
            mixpanel.people.increment('User Live Bet Amount');
          } else {
            mixpanel.people.increment('User Pre Bet Amount');
          }
          if (action.payload.isSystemSelected)
            mixpanel.people.increment('User System Bet Amount');
        }
      }
    }

    // Play Stream
    if (action.type === SET_LIVE_STREAM_START) {
      let activeEventTemp;
      if (History.location.pathname.split('/')[1] === 'canli-mac-izle') {
        const currentQueryParams = qs.parse(History.location?.search, { arrayFormat: 'bracket', parseNumbers: true, parseBooleans: true });
        const eventId = currentQueryParams['eventid'] ?? state.liveStream?.activeStreamInfo?.streamId;
        const activeGroup = state.liveStream.streamData?.data?.competitions?.find(group => group.events.some(event => event.webLiveStreamId == eventId));
        activeEventTemp = activeGroup?.events?.find(event => event.webLiveStreamId == eventId);
      }
      if (LocalStorage.get('liveStreamStop') !== null) {
        LocalStorage.remove('liveStreamStop');
      }
      let tempProvider;
      if (state.liveStream?.performInfo?.isHighlights || state.matchCard?.header?.data?.streamInfo?.highlightsSupported) {
        tempProvider = 'Perform (Highlights)';
      } else {
        tempProvider = state.matchCard?.header?.data?.streamInfo?.provider ||  activeEventTemp?.liveStreamProvider;
      }

      if (state.auth.isAuthenticated)
        mixpanel.people.increment('Number of Watch');

      mixpanel.track('Play Stream', {
        Teams: History.location.pathname.split('/')[1] === 'mac-karti' ? [state.matchCard?.event?.data[homeTeamName], state.matchCard?.event?.data[awayTeamName]] : [activeEventTemp?.bilyonerAwayTeam, activeEventTemp?.bilyonerHomeTeam],
        'Event ID': History.location.pathname.split('/')[1] === 'mac-karti' ? state.matchCard?.event?.data?.id : activeEventTemp?.sbsEventId,
        // eslint-disable-next-line no-nested-ternary
        'Event Type': History.location.pathname.split('/')[1] === 'mac-karti' ? (state.matchCard?.event?.data[bettingPhase] === 1 ? 'Canlı' : 'İddaa') : '',
        'Event Sport': History.location.pathname.split('/')[1] === 'mac-karti' ? GTA_SPORT_TYPE_NAMING[state.matchCard?.event?.data[sportType]] : SPORT_TYPE_NAMING[activeEventTemp?.sportType],
        'Event League': History.location.pathname.split('/')[1] === 'mac-karti' ? state.matchCard?.event?.data[leagueName] : '',
        'Event Time': History.location.pathname.split('/')[1] === 'mac-karti' ? state.matchCard?.event?.data[eventStartDate] : activeEventTemp?.matchDate,
        'Stream Provider': tempProvider,
        'Entry Point': History.location.pathname.split('/')[1] === 'mac-karti' ?  'Event Detay' : 'Canlı Yayın Sayfası'
      });
    }

    // Stop Stream
    if (action.type === SET_LIVE_STREAM_STOP) {

      const { totalSeconds } = action.payload;
      const currentQueryParams = qs.parse(History.location?.search, { arrayFormat: 'bracket', parseNumbers: true, parseBooleans: true });
      const eventId = currentQueryParams['eventid'] ?? state.liveStream?.activeStreamInfo?.streamId;
      const source = state.liveStream?.source;
      const activeGroup = state.liveStream?.streamData?.data?.competitions?.find(group => group?.events?.some(event => event?.webLiveStreamId == eventId));
      const activeEvent = activeGroup?.events?.find(event => event?.webLiveStreamId == eventId);
      LocalStorage.set('liveStreamStop', state?.liveStream?.matchCard?.event?.data?.id || eventId);

      let tempProviderStop;
      if (state.liveStream?.performInfo?.isHighlights || state.matchCard?.header?.data?.streamInfo?.highlightsSupported) {
        tempProviderStop = 'Perform (Highlights)';
      } else {
        tempProviderStop = state.matchCard?.header?.data?.streamInfo?.provider ||  activeEvent?.liveStreamProvider;
      }
      if (state.auth.isAuthenticated)
        mixpanel.people.increment('Seconds of Watch', totalSeconds || 0);
      if (action?.payload?.startTime) {
        mixpanel.track('Stop Stream', {
          Teams: source === 'mac-karti' ? [state.liveStream.matchCard?.event?.data[homeTeamName], state.liveStream.matchCard?.event?.data[awayTeamName]] : [activeEvent?.bilyonerAwayTeam, activeEvent?.bilyonerHomeTeam],
          'Event ID': source === 'mac-karti' ? state.liveStream.matchCard?.event?.data?.codeInt : activeEvent?.sbsEventId,
          // eslint-disable-next-line no-nested-ternary
          'Event Type': source === 'mac-karti' ? (state.matchCard?.event?.data[bettingPhase] === 1 ? 'Canlı' : 'İddaa') : '',
          'Event Sport': source === 'mac-karti' ? GTA_SPORT_TYPE_NAMING[state.liveStream.matchCard?.event?.data[sportType]] : SPORT_TYPE_NAMING[activeEvent?.sportType],
          'Event League': source === 'mac-karti' ? state.matchCard?.event?.data[leagueName] : '',
          'Event Time': source === 'mac-karti' ? state.liveStream.matchCard?.event?.data[eventStartDate] : activeEvent?.matchDate,
          'Stream Provider': tempProviderStop,
          'Seconds of Watch': totalSeconds || 0,
          'Entry Point': source === 'mac-karti' ? 'Event Detay' : 'Canlı Yayın Sayfası',
        });
      }
    }

    // Click Rebet
    if (action.type === ADD_MULTIPLE_EVENTS_TO_BETSLIP_SUCCESS) {

      const tabType = finderTab(History.location.pathname).tabType;

      const activeFilter
          = buildTribunMixPanelFilterData(
            LocalStorage.get(FILTER_V2.appliedFiltersLocalStorageKey) || {},
            getState().tribun?.tribunSortingOptions?.filterTabs || [],
            FILTER_V2.filterKeyMap,
            tabType,
            FILTER_V2.defaultSelectedFilters
          )?.activeFilterList;

      const activeSort
        = (LocalStorage.get(SORT.localStorageKey) || {})?.[tabType]?.value
        || (getState().tribun?.tribunSortingOptions?.sortingOptions?.data?.[0]?.value)
        || '-';

      if ( state?.betSlip.addedRebetButton === 'Kupona Ekle') {
        let tempPath = addOddAddedPoint(History.location.pathname);
        let tempTabObj = finderTab(History.location.pathname);

        const addedData = action.payload?.couponDetails?.selections.filter(couponDetail => action.payload?.details.find(detail => detail?.eventId === couponDetail?.eventId));

        mixpanel.track('Click Add to Coupon on Tribün', {
          'Coupon Type': tempPath === 'Tribün Kupon' ? 'Tribun' : '',
          'Tribun Bet User': action.payload?.sourceId,
          'Page Type': tempPath === 'Tribün Kupon' ? pageFinder(History.location.pathname) : '',
          'Active Tab': tempTabObj.tabPoint,
          'Active Filter': tempPath === 'Tribün Kupon' ? activeFilter : '',
          'Active Sort': tempPath === 'Tribün Kupon' || tempPath === 'Maç Kartı/Tribün' ? activeSort : '',
          'Added Event ID List': action.payload.events?.map(event => event?.eventId),
          'Added Teams List': action.payload.details?.map(match => match.name),
          'Added Event Sport List': action.payload.details?.map(event => GTA_SPORT_TYPE_NAMING[event.sportType]),
          'Added Event Time List': action.payload.details?.map(event => timeConverter(event?.eventDate)),
          'Added Event League List': state.betSlip?.couponDetails?.map(event => event?.leagueName),
          'Added Market Name List': action.payload.details?.map(event => event?.bets[0]?.marketName),
          'Added Market General Name List': addedData.map(event => event?.marketOutcomeName),
          'Added Selection List': action.payload.details?.map(event => event?.bets[0]?.betType),
          'Added Odd': action.payload.events.map(bet => bet?.odds),
          'Added Event Count': state.betSlip?.atrium?.betCount,
          'Total Odds': action.payload.couponDetails?.totalOdd,
          'Possible Win': costConverter(action.payload.couponDetails?.maxEarning),
          'Bet Amount': costConverter(action.payload.couponDetails?.couponCost) / action.payload.couponDetails?.multiple,
          'Multiple Coupon': action.payload.couponDetails?.multiple,
          'Total Bet Amount': costConverter(action.payload.couponDetails?.couponCost),
          'Bet Type': isLiveEvent(state.betSlip?.couponDetails) === true ? 'Canlı' : 'İddaa',
          'System Bet': action.payload.couponDetails?.systems.length > 1,
          'System Options': action.payload.couponDetails?.systems,
          'Tribun Bet Coupon ID': action.payload?.feedId,
          'Tribun Like Count': action.payload?.likeCount,
          'Tribun Comment Count': action.payload?.commentCount,
          'Event Count': action.payload.couponDetails?.selections.length,
          'Event ID List': action.payload.couponDetails?.selections.map(item=>item.eventId),
          'Event Sport List': action.payload.couponDetails?.selections?.map(event => GTA_SPORT_TYPE_NAMING[event.sportType]),
          'Event Time List': action.payload.couponDetails?.selections?.map(event => timeConverter(event?.eventDate)),
          'Market Name List': action.payload.couponDetails?.selections.map(item=>item.marketName),
          'Market General Name List': action.payload.couponDetails?.selections.map(item=>item.marketOutcomeName),
          Odd: action.payload.couponDetails?.selections.map(item=>item.odds),
          'Selection List': action.payload.couponDetails?.selections.map(item=>item.marketOutcomeName),
          'Teams List': action.payload.couponDetails?.selections.map(item=>item.eventName),
          'Event League List': state.betSlip?.couponDetails?.map(event => event?.leagueName),
          'Event Type List': action.payload.couponDetails?.selections?.map(event => event?.isLive ? 'Canlı' : 'İddaa'),
        });

      } else {
        let tempPath = addOddAddedPoint(History.location.pathname);
        let tempTabObj = finderTab(History.location.pathname);
        mixpanel.track('Click Rebet', {
          'Coupon Type': tempPath === 'Tribün Kupon' ? 'Tribun' : '',
          'Tribun Bet User': action.payload?.sourceId,
          'Page Type': tempPath === 'Tribün Kupon' ? pageFinder(History.location.pathname) : '',
          'Active Tab': tempTabObj.tabPoint,
          'Active Filter': tempPath === 'Tribün Kupon' ? activeFilter : '',
          'Active Sort': tempPath === 'Tribün Kupon' || tempPath === 'Maç Kartı/Tribün' ? activeSort : '',
          'Event ID List': action.payload.events?.map(event => event?.eventId),
          'Teams List': action.payload.details?.map(match => match.name),
          'Event Type List': action.payload.details?.map(event => event?.isLive ? 'Canlı' : 'İddaa'),
          'Event Sport List': action.payload.details?.map(event => GTA_SPORT_TYPE_NAMING[event.sportType]),
          'Event Time List': action.payload.details?.map(event => timeConverter(event?.eventDate)),
          'Event League List': state.betSlip?.couponDetails?.map(event => event?.leagueName),
          'Market Name List': action.payload.details?.map(event => event?.bets[0]?.marketName),
          'Selection List': action.payload.details?.map(event => event?.bets[0]?.betType),
          Odd: action.payload.events.map(bet => bet?.odds),
          'Event Count': state.betSlip?.atrium?.betCount,
          'Total Odds': action.payload.couponDetails?.totalOdd,
          'Possible Win': costConverter(action.payload.couponDetails?.maxEarning),
          'Bet Amount': costConverter(action.payload.couponDetails?.couponCost) / action.payload.couponDetails?.multiple,
          'Multiple Coupon': action.payload.couponDetails?.multiple,
          'Total Bet Amount': costConverter(action.payload.couponDetails?.couponCost),
          'Bet Type': isLiveEvent(state.betSlip?.couponDetails) === true ? 'Canlı' : 'İddaa',
          'System Bet': action.payload.couponDetails?.systems.length > 1 || action.payload.couponDetails?.systems[0] !== state.betSlip?.atrium?.betCount,
          'System Options': action.payload.couponDetails?.systems,
          'Tribun Bet Coupon ID': action.payload?.feedId,
          'Tribun Like Count': action.payload?.likeCount,
          'Tribun Comment Count': action.payload?.commentCount,
        });
      }
    }

    // Comment Coupon
    if (action.type === SEND_COMMENT_SUCCESS || action.type ===  SEND_COMMENT_FAILURE) {
      mixpanel.track('Comment Coupon', {
        'Event ID List': state.tribun.tribunCouponDetails?.data?.coupon?.selections?.map(event => event.eventId),
        'Teams List': state.tribun.tribunCouponDetails?.data?.coupon?.selections?.map(event => event.eventName),
        'Event Type List': state.tribun.tribunCouponDetails?.data?.coupon?.selections?.map(event =>  event?.isLive ? 'Canlı' : 'İddaa'),
        'Event Sport List': state.tribun.tribunCouponDetails?.data?.coupon?.selections?.map(event => GTA_SPORT_TYPE_NAMING[event.sportType]),
        'Event Time List': state.tribun.tribunCouponDetails?.data?.coupon?.selections?.map(event => timeConverter(event?.eventDate)),
        'Event League List': '',
        'Market Name List': state.tribun.tribunCouponDetails?.data?.coupon?.selections?.map(event => event?.marketName),
        'Selection List': state.tribun.tribunCouponDetails?.data?.coupon?.selections?.map(event => event?.marketOutcomeName),
        Odd: state.tribun.tribunCouponDetails?.data?.coupon?.selections?.map(bet => bet?.odds),
        'Event Count': state.tribun.tribunCouponDetails?.data?.coupon?.selections?.length,
        'Total Odds': state.tribun.tribunCouponDetails?.data?.coupon?.totalOdd,
        'Possible Win': costConverter(state.tribun.tribunCouponDetails?.data?.coupon?.maxEarning),
        'Bet Amount': costConverter(state.tribun.tribunCouponDetails?.data?.coupon?.couponCost) / costConverter(state.tribun.tribunCouponDetails?.data?.coupon?.multiple),
        'Multiple Coupon': state.tribun.tribunCouponDetails?.data?.coupon?.multiple,
        'Total Bet Amount': costConverter(state.tribun.tribunCouponDetails?.data?.coupon?.couponCost),
        'Bet Type': getCouponHasLive(state.tribun.tribunCouponDetails?.data?.coupon?.selections) ? 'Canlı' : 'İddaa',
        'System Bet': state.tribun.tribunCouponDetails?.data?.coupon?.system.length > 1 || costConverter(state.tribun.tribunCouponDetails?.data?.coupon?.system[0]) !== costConverter(state.tribun.tribunCouponDetails?.data?.coupon?.selections?.length),
        'System Options': state.tribun.tribunCouponDetails?.data?.coupon?.system,
        'Tribun User Name': state.tribun.tribunCouponDetails?.data?.user?.username,
        'Tribun Bet Coupon ID': state.tribun.tribunCouponDetails?.data?.feedId,
        Blocked: action.type !== SEND_COMMENT_SUCCESS,
        'Coupon Settlement': getCouponSetlement(state.tribun.tribunCouponDetails?.data?.coupon?.status),
      });
    }

    // Like Coupon
    if (action.type === LIKE_OR_UNLIKE_COUPON_SUCCESS && action.isLiked) {
      mixpanel.track('Like Coupon', {
        'Event ID List': action?.coupon?.selections?.map(event => event.eventId),
        'Teams List': action?.coupon?.selections?.map(event => event.eventName),
        'Event Type List': action.coupon?.selections?.map(event =>  event?.isLive ? 'Canlı' : 'İddaa'),
        'Event Sport List': action.coupon?.selections?.map(event => GTA_SPORT_TYPE_NAMING[event.sportType]),
        'Event Time List': action.coupon?.selections?.map(event => timeConverter(event?.eventDate)),
        'Event League List': '',
        'Market Name List': action?.coupon?.selections?.map(event => event?.marketName),
        'Selection List': action?.coupon?.selections?.map(event => event?.marketOutcomeName),
        Odd: action?.coupon?.selections?.map(bet => bet?.odds),
        'Event Count': action?.coupon?.selections?.length,
        'Total Odds': action?.coupon?.totalOdd,
        'Possible Win': costConverter(action?.coupon?.maxEarning),
        'Bet Amount': costConverter(action?.coupon?.couponCost) / costConverter(action?.coupon?.multiple),
        'Multiple Coupon': action?.coupon?.multiple,
        'Total Bet Amount': costConverter(action?.coupon?.couponCost),
        'Bet Type': getCouponHasLive(action?.coupon?.selections) ? 'Canlı' : 'İddaa',
        'System Bet': action?.coupon?.system.length > 1 || (
          state.tribun.tribunCouponDetails.data
            ? (costConverter(state.tribun.tribunCouponDetails?.data?.coupon?.system[0]) !== costConverter(state.tribun.tribunCouponDetails?.data?.coupon?.selections?.length))
            : false
        ),
        'System Options': action?.coupon?.system,
        'Tribun User Name': action?.username,
        'Tribun Bet Coupon ID': action.feedId,
        'Coupon Settlement': getCouponSetlement(action?.coupon?.status),
      });
    }

    // Share Coupon on Tribun

    if (action.type === SHARE_TRIBUN_COUPON_SUCCESS) {
      const isSharedFromCoupons = shareCouponPlace(action.coupon);
      mixpanel.track('Share Coupon on Tribun', {
        'Shared Place': isSharedFromCoupons ? 'My bets' : 'After Place Bet',
        'Tribun User Name': isSharedFromCoupons ? tribunUsernameCheck(action.coupon?.shared) : tribunUsernameCheck(state.playCoupon?.data?.coupon?.source),
        'Total Odds': isSharedFromCoupons ? action.coupon?.totalOdd : state.playCoupon?.data?.coupon?.totalOdd,
        'Possible Win': isSharedFromCoupons ? costConverter(action.coupon?.expectedWinAmount) : costConverter(state.playCoupon?.data?.coupon?.expectedWinAmount),
        'Multiple Coupon': couponCountCheck(state.playCoupon?.data, action.coupon ),
        'Total Bet Amount': isSharedFromCoupons ? costConverter(action.coupon?.price || action.coupon?.couponCost) : costConverter(state.playCoupon?.data?.coupon?.couponCost),
        'Bet Type': hasLiveEventConverter(action.coupon),
        'System Bet': isSharedFromCoupons ? action.coupon?.systems?.length > 1 : state.playCoupon?.data?.coupon?.system?.length > 1,
        'Coupon ID': isSharedFromCoupons ? action.coupon?.couponId :  state.playCoupon?.data?.coupon?.transactionId,
        'System Options': isSharedFromCoupons ? action.coupon?.systems : state.playCoupon?.data?.coupon?.system,
      });
    }

    // Update Balance
    if (action.type === UPDATE_USER_BALANCE_SUCCESS) {
      if (state.auth.isAuthenticated) {
        mixpanel.people.set({ Balance: state.auth.data.balance });
        mixpanel.register({ Balance: state.auth.data.balance });
      }
    }

    if (action.type === FORGOT_PASSWORD_OPTIONS_SUCCESS) {
      mixpanel.track('Click Renew Password');
    }

    if (action.type === FORGOT_PASSWORD_OPTIONS_FAILURE) {
      const { code, domain } = action.payload?.response?.data || {};

      mixpanel.track('Click Renew Password', {
        ...(code ? { 'Error Code': `${domain || ''}${code}` } : {})
      });
    }

    if (action.type === SAVE_FORGOT_PASSWORD_UNKNOWN_USER_DATA) {
      mixpanel.track('Choose Password Renew Type', {
        'Password Renew Type': 'Telefon'
      });
    }

    if (action.type === FORGOT_PASSWORD_SEND_EMAIL_REQUEST) {
      mixpanel.track('Choose Password Renew Type', {
        'Password Renew Type': 'E-mail'
      });
    }

    if (action.type === FORGOT_PASSWORD_SEND_OTP_REQUEST) {
      mixpanel.track('View Sms Verification Page');
    }

    if (action.type === FORGOT_PASSWORD_OTP_VERIFY_SUCCESS) {
      mixpanel.track('Complete SMS Verification', { Source: 'Change Password' });
    }

    if (action.type === SAVE_FORGOT_PASSWORD_UNKNOWN_USER_DATA) {
      const renewTypeOptions = getRenewTypeOptions(state);

      mixpanel.track('View Renew Password Page', {
        'Password Renew Type': 'Telefon',
        ...(renewTypeOptions.length ? { 'Renew Type Options': renewTypeOptions } : {})
      });
    }

    if (action.type === FORGOT_PASSWORD_SEND_EMAIL_REQUEST) {
      const renewTypeOptions = getRenewTypeOptions(state);

      mixpanel.track('View Renew Password Page', {
        'Password Renew Type': 'E-mail',
        ...(renewTypeOptions.length ? { 'Renew Type Options': renewTypeOptions } : {})
      });
    }

    if (action.type === FORGOT_PASSWORD_CHANGE_WITH_PHONE_NUMBER_SUCCESS) {
      mixpanel.track('Complete Renew Password', {
        'Password Renew Type': 'Telefon'
      });
    }

    if (action.type === FORGOT_PASSWORD_CHANGE_WITH_EMAIL_SUCCESS) {
      mixpanel.track('Complete Renew Password', {
        'Password Renew Type': 'E-mail'
      });
    }

    if (action.type === VIEW_EVENT_LIST_MIXPANEL) {
      // Prevent duplicate events from breadcrumb navigation
      if (action.source === 'breadcrumb') {
        return next(action);
      }

      const { activeFilters, activeMarketGroupId, isNewHeader, activeGameCount } = action.payload;
      const { bulletinType, sportType, events = {}, marketGroups } = state.sportsBookHash;
      const sportsBookActiveFilters = activeFilters;
      const selectedMarketGroupType = marketGroups.find(item=>item.id === activeMarketGroupId);
      const isVisibleMarketSlider = marketGroups?.length > 1;

      const orderFilterStatus = bultenOrderFilterStatus(sportsBookActiveFilters, state.auth);

      const isEventRowCollapsed = sessionStorage.getItem('isEventRowCollapsed') === 'true';

      if (mixpanel?.__loaded) {
        const trackingData = {
          'Sport Type': `${GTA_SPORT_TYPE_NAMING[sportType] }${bulletinType === BULLETIN_TYPES.LIVE ? ' Canlı' : ''}`,
          'Active Game Count': activeGameCount ?? Object.keys(events).length,
          'Order Filter Status': orderFilterStatus,
          'Play Ratio Status': sportsBookActiveFilters.showPercentages || false,
          'Comment Filter Status': mixpanelFilterParser(sportsBookActiveFilters, FILTER_DATA_TYPES.writers),
          'Single Game Filter Status': sportsBookActiveFilters.filterRequestType?.some(filter => filter.filterType === 'MBS') || false,
          ...(!isNewHeader && { 'Bilyoner TV Status': mixpanelFilterParser(sportsBookActiveFilters, FILTER_DATA_TYPES.liveStreamLeagues) }),
          'Favorite Filter Status': sportsBookActiveFilters.favouriteEvents || false,
          'League Filter Status': mixpanelFilterParser(sportsBookActiveFilters, FILTER_DATA_TYPES.league),
          'Date Filter Status': mixpanelFilterParser(sportsBookActiveFilters, FILTER_DATA_TYPES.date),
          'Hour Filter Status': orderFilterStatus === 'Saate Göre',
          ...(!isNewHeader && { 'MBS Filter Status': mixpanelFilterParser(sportsBookActiveFilters, 'MBS') }),
          'Market Group Type': selectedMarketGroupType?.name || '-',
          ...(!isNewHeader && { 'Fast Game Filter Status': sportsBookActiveFilters?.[FILTER_DATA_TYPES.hasRapidMarket] || false, }),
          'Cylinder Bulletin Type': isVisibleMarketSlider ? selectedMarketGroupType?.name : '-',
          'Cylinder Bulletin Change Type': 'Default',
          'Event List Display Mode': isEventRowCollapsed ? 'Detaysız' : 'Detaylı'
        };

        mixpanel.track('View Event List', trackingData);
      }
    }

    if (action.type === SPORTSBOOK_FILTER_CLICKED) {
      const { filterName, isActive, source } = action.payload;

      switch (filterName) {
        case SORTBYLEAGUE:
          mixpanel.track('Click Order Change On Event List', {
            'Order Type': 'Lige Göre',
          });
          break;
        case BYTIME:
          mixpanel.track('Click Order Change On Event List', {
            'Order Type': 'Saate Göre',
          });
          break;
        case SORTBYPOPULAR:
          mixpanel.track('Click Order Change On Event List', {
            'Order Type': 'Popüler',
          });
          break;
        case SORTBYPERSONAL:
          mixpanel.track('Click Order Change On Event List', {
            'Order Type': 'Sana Özel',
          });
          break;
        case 'MBS1':
          mixpanel.track('Click Single Game Filter On Event List', {
            'Single Game Filter Status': isActive,
          });
          break;
        case FAVORITES:
          mixpanel.track('Click Favorite Filter On Event List', {
            'Favorite Filter Status': isActive,
          });
          break;

        default:
          break;
      }

      if ([SORTBYLEAGUE, BYTIME, SORTBYPOPULAR, SORTBYPERSONAL].includes(filterName)) {
        mixpanel.track('Click Hour Filter On Event List', {
          'Hour Filter Status': filterName === BYTIME,
        });
      }


      if (filterName[SEARCH]) {
        mixpanel.track('Search Event List', {
          'Search Value': filterName[SEARCH],
        });
      }
      if (source === 'filterPanel' && filterName && typeof filterName === 'object') {
        const hasActiveFilterOfType = type => !!filterName?.filterRequestType?.find(filter => filter.filterType === type)?.filterIds?.length;

        if (hasActiveFilterOfType(FILTER_DATA_TYPES.league)) {
          mixpanel.track('Click Leauge Filter On Event List', {
            'Filtered Leagues': mixpanelFilterParser(filterName, FILTER_DATA_TYPES.league),
          });
        }
        if (hasActiveFilterOfType(FILTER_DATA_TYPES.date)) {
          mixpanel.track('Click Date Filter On Event List', {
            'Filtered Dates': mixpanelFilterParser(filterName, FILTER_DATA_TYPES.date),
          });
        }
        if (hasActiveFilterOfType(FILTER_DATA_TYPES.writers)) {
          mixpanel.track('Click Comment Filter On Event List', {
            'Comment Filter Status': hasActiveFilterOfType(FILTER_DATA_TYPES.writers),
          });
        }
        if (hasActiveFilterOfType(FILTER_DATA_TYPES.mbs)) {
          mixpanel.track('Click MBS Filter On Event List', {
            'MBS Filter Status': mixpanelFilterParser(filterName, FILTER_DATA_TYPES.mbs),
          });
        }
      }
    }


    // Click My Bets Tabs
    if ([
      GET_CONTINUED_COUPONS_SUCCESS,
      GET_WON_COUPONS_SUCCESS,
      GET_LOST_COUPONS_SUCCESS,
      GET_SAVED_COUPONS_SUCCESS,
      GET_REJECTED_COUPONS_SUCCESS,
      GET_OUT_RIGHT_CONTINUE_COUPONS_SUCCESS,
      GET_OUT_RIGHT_WON_COUPONS_SUCCESS,
      GET_OUT_RIGHT_LOST_COUPONS_SUCCESS,
      GET_OUT_RIGHT_SAVED_COUPONS_SUCCESS
    ].includes(action.type)) {
      const clickedTabName = (() => {
        switch (action.type) {
          case 'GET_WON_COUPONS_SUCCESS' || 'GET_OUT_RIGHT_WON_COUPONS_SUCCESS':
            return 'Kazanan';
          case 'GET_LOST_COUPONS_SUCCESS' || 'GET_OUT_RIGHT_LOST_COUPONS_SUCCESS':
            return 'Kaybeden';
          case 'GET_SAVED_COUPONS_SUCCESS' || 'GET_OUT_RIGHT_SAVED_COUPONS_SUCCESS':
            return 'Kayıtlı';
          case 'GET_REJECTED_COUPONS_SUCCESS':
            return 'Onaylanmamış';
          default:
            return 'Devam Eden';
        }
      })();
      mixpanel.track('Click My Bets Tabs', {
        'Clicked Tab Name': clickedTabName,
        'Listed Coupon Count': action.payload.length,
        'Bet Type': action.type.includes('OUT_RIGHT') ? 'UV' : 'İddaa'
      });
    }

    // Sportoto Event List
    if (action.type === SPOR_TOTO_GET_EVENTS_SUCCESS ) {
      mixpanel.track('View Sportoto Play Page', {
        Status: !!action.payload.gameCycleEntityModel.eventVOs.length,
      });
    }

    if (action.type === SPOR_TOTO_COUPONS_SUCCESS || action.type === SPOR_TOTO_COUPONS_FAILURE) {
      const { list = [], activeTab } = action.payload || {};
      const isSportotoPage = History.location.pathname.indexOf('/spor-toto') === 0;
      const isSportotoCouponsPage = History.location.pathname.includes('/kuponlarim/spor-toto');

      const clickedTabName = (() => {
        switch (activeTab) {
          case 'WON':
            return 'Kazanan';
          case 'LOST':
            return 'Kaybeden';
          case 'SAVED':
            return 'Kayıtlı';
          default:
            return 'Devam Eden';
        }
      })();

      if (isSportotoPage ) {
        mixpanel.track('View Sportoto My Bets Page', {
          'Listed Coupon Count': list.length,
          'Clicked Place': 'Sportoto',
          'Tab Name': clickedTabName
        });
      } else if (isSportotoCouponsPage) {
        mixpanel.track('View Sportoto My Bets Page', {
          'Listed Coupon Count': list.length,
          'Clicked Place': 'Kuponlarım',
          'Tab Name': clickedTabName
        });
        mixpanel.track('View My Bets - Spor Toto Page', {
          'Active Coupon Count': list.length,
        });
      }

    }

    if (action.type === SPOR_TOTO_RESULT_BY_WEEKLY_SUCCESS) {
      const drawInfo = action.payload?.drawInformationModel?.drawInfoVOs;
      mixpanel.track('View Sportoto Results Page', {
        'Program Name':
          drawInfo && drawInfo.length > 0
            ? drawInfo[0]?.weekNumberText
            : '',
        'Resulted Match Count':
          drawInfo && drawInfo.length > 0
            ? drawInfo[0]?.drawInfoXMLParsed?.game?.draw?.event.filter(
              item => item.result !== ''
            ).length
            : 0,
      });
    }

    if (action.type === SPOR_TOTO_PLAY_SUCCESS) {
      const { eventsData } = state.sporToto.sporTotoCommonData;
      const { weekNumberText } = eventsData?.events && eventsData?.events.gameCycleEntityModel;

      mixpanel.track('Complete Sportoto Bet', {
        'Total Bet Amount': costConverter(action.payload.totalAmount),
        'Colon Number': action.payload.columnCount,
        'Coupon Multiplier': action.payload.multiplier,
        'Program Name': weekNumberText,
        'Year of Birth': state.auth.data.yearOfBirth,
        Occupation: state.auth.data.occupationName
      });

      if (state.auth.isAuthenticated) {
        mixpanel.people.increment('User Sportoto Bet Count');
        mixpanel.people.increment('User Sportoto Bet Amount', costConverter(action.payload.totalAmount));
      }
    }

    if (action.type === SPOR_TOTO_GET_POPULAR_SELECTIONS) {
      mixpanel.track('Click Sportoto Popular Selections');
    }

    if (action.type === SPOR_TOTO_RANDOM_SELECTIONS) {
      mixpanel.track('Click Sportoto Random Selections');
    }

    if (action.type === SPOR_TOTO_CANCEL_COUPON_SUCCESS) {
      if (action.payload.coupons && action.payload.coupons.length > 0 && action.payload.coupons[0].isCancelled) {
        mixpanel.track('Cancel Sportoto Coupon');
      }
    }

    if (action.type === SPOR_TOTO_DELETE_SAVED_COUPON_SUCCESS) {
      mixpanel.track('Delete Saved Coupon');
    }

    if (action.type === SPACE_COUPON_MIX_PANEL) {
      const payload = action.payload;
      const eventType = action.eventType;
      const couponDetail = action.item;
      const shareType = action.shareType;

      let name = 'Click Space Coupon Detail';
      if (eventType === 'follow') {
        name = 'Click Follow on Space Coupons';
      } else if (eventType === 'clickActiveCount') {
        name = 'Click See Active Coupons';
      } else if (eventType === 'share') {
        name = 'Click Share Coupon on Space Coupons';
      }

      if (couponDetail) {

        const data = {
          'Coupon Rank': payload.order,
          'Active Tab': SPACE_COUPON_MIXPANEL_MAP[payload.tabType],
          'Bet Type': getCouponHasLive(couponDetail.coupon?.selections) ? 'Canlı' : 'İddaa',
          'Coupon ID': couponDetail.coupon?.couponId,
          'Total Real Odds': couponDetail.coupon.winningOdd,
          'Total Win Amount': couponDetail.coupon.earning,
          'System Bet': couponDetail.coupon?.system.length > 1 || costConverter(couponDetail.coupon?.system[0]) !== costConverter(couponDetail.coupon?.selections?.length),
          'System Options': couponDetail.coupon?.system,
          'Multiple Coupon': couponDetail.coupon?.multiple,
          'Tribun Bet User': couponDetail.user?.userId,
          'Tribun Username': couponDetail.user?.username,
          'Tribun Comment Count': couponDetail?.comments,
          'Tribun Like Count': couponDetail?.likes,
          'Active Bet Count': couponDetail?.user?.stats?.activeCouponSize,
          'Active Date Filter': payload.dateRange?.displayName
        };

        if (eventType === 'share') {
          Object.assign(data, { 'Shared App': shareType });
        }

        mixpanel.track(name, data);
      }
      // Play TJK Stream
      if (action.type === SET_TJK_LIVE_STREAM_START) {
        const { channel } = action.payload;
        const page = History.location.pathname.split('/')[1] === 'tjk' ? 'At Yarışı Program Sayfası' : 'Canlı Yayın Sayfası';

        if (state.auth.isAuthenticated)
          mixpanel.people.increment('Number of Watch Horse Racing');

        mixpanel.track('Play Stream TJK TV', {
          'Channel Name': channel,
          'Entry Point': page,
        });
      }

      // Stop TJK Stream
      if (action.type === SET_TJK_LIVE_STREAM_STOP) {
        const { totalSeconds, channel } = action.payload;
        const page = History.location.pathname.split('/')[1] === 'tjk' ? 'At Yarışı Program Sayfası' : 'Canlı Yayın Sayfası';

        if (state.auth.isAuthenticated)
          mixpanel.people.increment('Seconds of Watch Horse Racing', totalSeconds || 0);

        mixpanel.track('Stop Stream TJK TV', {
          'Channel Name': channel,
          'Entry Point': page,
          'Seconds of Watch Horse Racing': totalSeconds || 0,
        });
      }
    }

    if (action.type === FOLLOW_TRIBUN_USER_SUCCESS) {
      if (action.follow === true) {
        mixpanel.track('Follow User', {
          'Page Type': tribunPageTypeHelper(action?.tabType),
          'Tribun User Name': action?.username,
        });
      } else {
        mixpanel.track('Unfollow User', {
          'Page Type': tribunPageTypeHelper(action?.tabType),
          'Tribun User Name': action?.username,
        });
      }
    }

    if (action.type === GET_PUSH_FOLLOW_SUCCESS) {
      mixpanel.track('Get Notification User', {
        'Page Type': tribunPageTypeHelper(action?.tabType),
        'Tribun User Name': action?.username,
      });
    }

    if (action.type === GET_PUSH_UNFOLLOW_SUCCESS) {
      mixpanel.track('Disable Notifications from User', {
        'Page Type': tribunPageTypeHelper(action?.tabType),
        'Tribun User Name': action?.username,
      });
    }

    if (action.type === MUTE_TRIBUN_USER_SUCCESS) {
      mixpanel.track('Mute User', {
        'Tribun User Name': action?.username,
        'Mute Point': muteMutePointHelper(action?.tabType),
        'Mute/Unmute': action?.isUnmute ? 'Unmute' : 'Mute',
      });
    }

    if (action.type === HIDE_TRIBUN_FEED_COUPON_SUCCESS && action.hide) {
      mixpanel.track('Hide Coupon', {
        'Tribun User Name': action?.tribunUserName,
        'Hide Point': muteMutePointHelper(action?.tabType),
      });
    }

    // Fast Deposit Analytics
    if (action.type === FAST_DEPOSIT_VIEW_PAGE) {
      mixpanel.track('View Fast Deposit Page', {
        'IBAN Count': action.payload?.ibanCount ?? 0,
        'Bank Names': action.payload?.bankNames ?? []
      });
    }

    if (action.type === FAST_DEPOSIT_CLICK_SEND_REQUEST) {
      mixpanel.track('Click Send Payment Request on Fast Deposit Page', {
        'Payment Request Point': action.payload?.paymentRequestPoint ?? ''
      });
    }

    if (action.type === FAST_DEPOSIT_CLICK_CANCEL_BUTTON) {
      mixpanel.track('Click Cancel Button on Fast Deposit Actionsheet');
    }

    if (action.type === FAST_DEPOSIT_CLICK_CONFIRM_BUTTON) {
      mixpanel.track('Click Confirm Button on Fast Deposit Actionsheet', {
        'Fast Deposit Amount': action.payload?.amount ?? ''
      });
    }

    if (action.type === FAST_DEPOSIT_CLICK_HOW_TO_BUTTON) {
      mixpanel.track('Click How to Deposit Button');
    }

    if (action.type === FAST_DEPOSIT_CLICK_HELP_BUTTON) {
      mixpanel.track('Click Help Button on Bilyoner Anında', {
        'Fast Deposit Amount': action.payload?.amount ?? '',
        'Bank Name': action.payload?.bankName ?? ''
      });
    }

    if (action.type === FAST_DEPOSIT_CLICK_CANCEL_INFO) {
      mixpanel.track('Click Cancel Info Button', {
        'Fast Deposit Amount': action.payload?.amount ?? '',
        'Bank Name': action.payload?.bankName ?? ''
      });
    }

    if (action.type === FAST_DEPOSIT_VIEW_CANCEL_REASON) {
      mixpanel.track('View Cancel Reason Bottomsheet', {
        'Cancellation Reason': action.payload?.cancelReason ?? ''
      });
    }

    if (action.type === FAST_DEPOSIT_CLICK_RETRY_BUTTON) {
      mixpanel.track('Click Retry Button on Fast Deposit Page');
    }

    return next(action);
  };
};
